/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {SelectDropdownOptionModel} from './models/select-dropdown-option.model';

@Component({
    selector: 'app-select-dropdown',
    templateUrl: './select-dropdown.component.html',
    styleUrls: [
        '../../../shared/styles/select-dropdown.css',
        './select-dropdown.component.css'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectDropdownComponent implements OnInit {
    @Input() dropdownDefaultButtonText: String;
    @Input() dropdownData: SelectDropdownOptionModel[];

    @Output() selectedOption = new EventEmitter<SelectDropdownOptionModel>();

    constructor() {
    }

    ngOnInit(): void {
    }

    dropdownItemDataCy(itemValue: string, isButton?: boolean): string {
        if (itemValue != null) {
            if (isButton) {
                return `dropdown-item-button-${itemValue.toLowerCase()
                        .replace(new RegExp(/\s/g), '-')}`;
            } else {
                return `dropdown-item-text-${itemValue.toLowerCase()
                        .replace('(', '')
                        .replace(')', '')
                        .replace(new RegExp(/\s/g), '-')}`;
            }
        }
    }
}
